<footer class="site-footer">
  <!-- Main Footer Section -->
  <div class="footer-main">
    <div class="footer-container">
      <!-- Left: Company Info -->
      <div class="footer-company">
        <p class="company-name">{{ companyInfo.name }}</p>
        <p class="company-address">{{ companyInfo.address1 }}</p>
        <p class="company-address">{{ companyInfo.address2 }}</p>
        <vb-link
          [href]="companyInfo.phoneHref"
          color="white"
          underline="hover"
        >{{ companyInfo.phone }}</vb-link>
      </div>

      <!-- Center: Navigation Links -->
      <div class="footer-nav">
        <div class="footer-nav-column">
          <vb-link [href]="externalLinks.aboutUs" [external]="true" underline="hover" color="white">About Us</vb-link>
          <vb-link [href]="externalLinks.careers" [external]="true" underline="hover" color="white">Careers</vb-link>
        </div>
        <div class="footer-nav-column">
          <vb-link [href]="externalLinks.leasingManagers" [external]="true" underline="hover" color="white">Leasing Managers</vb-link>
          <vb-link [href]="externalLinks.newsroom" [external]="true" underline="hover" color="white">Newsroom</vb-link>
        </div>
      </div>

      <!-- Right: Contact Button -->
      <div class="footer-contact">
        <a
          [href]="externalLinks.contactUs"
          target="_blank"
          rel="noopener noreferrer"
        >
          <vb-button variant="outline">Contact Us</vb-button>
        </a>
      </div>
    </div>
  </div>

  <!-- Logo Section -->
  <div class="footer-logo-section">
    <div class="footer-container footer-logo-container">
      <!-- Left: Logo -->
      <div class="footer-brand">
        <img
          src="VerticalBridge_Logo3_wht.svg"
          alt="Vertical Bridge"
          class="footer-logo"
        />
      </div>

      <!-- Right: Social & Badge -->
      <div class="footer-social">
        <a
          [href]="externalLinks.linkedin"
          target="_blank"
          rel="noopener noreferrer"
          class="social-link"
          aria-label="Follow Vertical Bridge on LinkedIn"
        >
          <span class="linkedin-icon-wrapper">
            <span class="linkedin-in">in</span>
          </span>
          <span class="follow-us-text">Follow Us</span>
        </a>
        <img
          src="VBAsset_Carbon_logo.svg"
          alt="Carbon Neutral Certified"
          class="carbon-badge"
        />
      </div>
    </div>
  </div>

  <!-- Copyright Section -->
  <div class="footer-copyright-section">
    <div class="footer-container footer-copyright-container">
      <!-- Left: Copyright -->
      <div class="copyright-text">
        &copy; {{ currentYear }} Vertical Bridge, REIT, LLC. All Rights Reserved
      </div>

      <!-- Right: Legal Links -->
      <div class="legal-links">
        <vb-link [href]="externalLinks.termsOfUse" [external]="true" underline="hover" color="white">Terms of Use</vb-link>
        <span class="legal-separator" aria-hidden="true">|</span>
        <vb-link [href]="externalLinks.privacyPolicy" [external]="true" underline="hover" color="white">Privacy Policy</vb-link>
        <span class="legal-separator" aria-hidden="true">|</span>
        <vb-link [href]="externalLinks.accessibility" [external]="true" underline="hover" color="white">Accessibility</vb-link>
      </div>
    </div>
  </div>
</footer>
